import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { FontStyle } from "../style/FontStyle";
import { SlingoStyle } from "../style/SlingoStyle";
/**
 * AbstractSummaryCellProperties.ts
 */
export class AbstractSummaryCellProperties extends AbstractViewProperties {
    constructor(iconAsset, nameLangKey, currency) {
        super();
        this.iconAsset = iconAsset;
        this.nameLangKey = nameLangKey;
        this.currency = currency;
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            (this.iconAsset === other.iconAsset) &&
            (this.nameLangKey === other.nameLangKey) &&
            (this.currency === other.currency) &&
            this.backgroundProperties.equals(other.backgroundProperties) &&
            this.iconProperties.equals(other.iconProperties) &&
            this.nameFieldProperties.equals(other.nameFieldProperties) &&
            this.amountFieldProperties.equals(other.amountFieldProperties) &&
            (this.size ? this.size.equals(other.size) : this.size === other.size);
    }
    setDefaultValues() {
        this.backgroundProperties = new SpriteProperties(SlingoStyle.GAME_SUMMARY_CELL, SlingoStyle.MODULE);
        this.iconProperties = new SpriteProperties(this.iconAsset, SlingoStyle.MODULE);
        this.nameFieldProperties = new TextFieldProperties(FontStyle.GAME_SUMMARY_CELL, null, this.nameLangKey, ControlConstants.LEFT, ControlConstants.CENTER);
        this.amountFieldProperties = new TextFieldProperties(FontStyle.GAME_SUMMARY_CELL, null, null, ControlConstants.RIGHT, ControlConstants.CENTER);
    }
}
//# sourceMappingURL=AbstractSummaryCellProperties.js.map